import {
  AboutUsHeader,
  FoundationalPrinciples,
  InfoBlurbSection,
  MeetOurTeam,
} from "../components/AboutUsComponents";
import { useEffect } from "react";

// Define styles object
const styles = {
  aboutUsContainer: {
    width: "100%",
    height: "100%",
    padding: "0 2%",
  },
};

// React component
export const AboutUs = () => {
  useEffect(() => {
    document.title = "About Us";
  }, []);
  return (
    <div style={styles.aboutUsContainer} className="about-us-container">
      <AboutUsHeader />
      <InfoBlurbSection />
      <FoundationalPrinciples />
      <MeetOurTeam />
    </div>
  );
};
